import httpclient from '../base/httpclient';
import DIApi from './_diApi';

class SystemAccountAPI extends DIApi {
  controllerName = 'Accounts';
  /**
   * Chuyển dữ liệu dữu liệu danh mục tài khoản
   * DVTHUC 29/05/1012
   */
  async updateTranferAccountData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferData',
      data: payload,
    };
    return await httpclient.postAsync(request, true);
  }

  /**
   * chuyển tk hạch toán
   * dvthuc 29/
   */
  async changeAccount(param) {
    const apiUrl = this.getAPIUrl();

    const request = {
      url: apiUrl + '/changeAccount',
      data: {
        ...param,
      },
    };

    return await httpclient.postAsync(request);
  }

  /**
   * Chuyển dữ liệu dữu liệu list danh mục
   * ntban - 4.7.2023
   */
  async updateTranferListData(payload) {
    const request = {
      url: this.getAPIUrl() + '/tranferListData',
      data: payload,
    };
    return await httpclient.postAsync(request, true);
  }

  /**
   * Insert tài khoản 216, 218, 467 sau khi enable option 'Kế toán tài sản kết cấu hạ tầng giao thông thủy lợi' trong Nghiệp vụ/Nghiệp vụ khác
   * ndchien1 - 05/07/2023
   */
  async insertOtherBusiness() {
    const request = {
      url: this.getAPIUrl() + '/otherBusiness',
    };
    return await httpclient.postAsync(request, true);
  }

  /**
   * Delete tài khoản 216, 218, 467 sau khi disable option 'Kế toán tài sản kết cấu hạ tầng giao thông thủy lợi' trong Nghiệp vụ/Nghiệp vụ khác
   * ndchien1 - 05/07/2023
   */
  async deleteOtherBusiness() {
    const request = {
      url: this.getAPIUrl() + '/otherBusiness',
    };
    return httpclient.deleteAsync(request, true);
  }

  /**
   * Thực hiện check phát sinh tài khoản 009
   * pdtai 13.09.2023
   */
  async checkDataGeneration(payload) {
    const request = {
      url: this.getAPIUrl() + '/checkDataGeneration',
      data: payload,
    };
    return httpclient.getAsync(request, true);
  }
}

export default new SystemAccountAPI();
